<template>
    <div style=" padding: 24px 17px 0;">
        <template v-if="reportList.length > 0 ">
            <div class='report_box'>
                <div class="report-title">
                    2022/5/2 创建勘察报告
                </div>
                <div class="report-content-box" v-for="(item,index) in reportList" @click="goReportInfo">
                    <img class="report-icon" src="@/assets/images/archives/dossier/arrow_icon.png" alt="">
                    <div class="report-content-icon">勘察报告</div>
                    <div class="line-box"></div>
                    <div class="report-info-box">
                        <div class="report-info-item flc2">
                            <div class="report-item-title">房屋类型：</div>
                            <div class="report-item-content flc2">{{ item.type }}</div>
                        </div>
                        <div class="report-info-item flc2">
                            <div class="report-item-title">装修情况：</div>
                            <div class="report-item-content flc2">{{ item.now }}</div>
                        </div>

                        <div class="report-info-item flc2">
                            <div class="report-item-title">房屋面积：</div>
                            <div class="report-item-content flc2">{{ item.area }}</div>
                        </div>

                        <div class="report-info-item flc2">
                            <div class="report-item-title">审批时间：</div>
                            <div class="report-item-content flc2">{{ item.time }}</div>
                        </div>
                    </div>
                </div>

            </div>
        </template>
        <template v-else>
            <img class="empty-img" src="@/assets/images/archives/dossier/contract_not.png" alt="">
            <div class="empty-info">暂无信息</div>
        </template>
    </div>

</template>
<script>


export default {
    name: "report",

    // 组件注册
    components: {},
    data() {
        return {
            reportList: [
                {
                    type: '别墅',
                    now: '毛坯房',
                    area: '123',
                    time: '2022.4.2'
                },
                {
                    type: '别墅',
                    now: '毛坯房',
                    area: '123',
                    time: '2022.4.2'
                },
                {
                    type: '别墅',
                    now: '毛坯房',
                    area: '123',
                    time: '2022.4.2'
                },
                {
                    type: '别墅',
                    now: '毛坯房',
                    area: '123',
                    time: '2022.4.2'
                },
            ]
        };
    },
    props: {},
    //计算属性
    computed: {},
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        goReportInfo () {
            this.$router.push('/archives/survey/reportinfo')
        }
    },
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}
.empty-img {
    width: 400px;
    height: 380px;
    display: block;
    margin: 0 auto;
}
.empty-info {
    text-align: center;
    padding: 20px 0 80px;
    font-size: 28px;
    font-weight: 400;
    color: #999999;
}
.report_box {
    width: 100%;
    height: 100%;
    padding-left: 42px;
    position: relative;
    &:before {
        content: '';
        height: 100%;
        left: 7px;
        top: 15px;
        width: 2px;
        z-index: 1;
        position: absolute;
        background-image: linear-gradient(
                #DDDDDD 0%,
                #DDDDDD 50%,
                transparent 50%
        );
        background-size: 2px 16px;
        background-repeat: repeat-y;
    }

    .report-title {
        font-size: 24px;
        font-weight: 400;
        margin-bottom: 32px;
        color: #3D3C4F;
        position: relative;

        &:before {
            content: '';
            position: absolute;
            width: 16px;
            height: 16px;
            background: #0D53FC;
            border-radius: 16px;
            top: 10px;
            left: -42px;
            z-index: 3;
        }
    }


    .report-content-box {
        background: #F9F9FB;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        width: 100%;
        margin-bottom: 20px;
        position: relative;
        padding-bottom: 16px;

        .report-icon {
            position: absolute;
            top: 60%;
            right: 20px;
            width: 30px;
            height: 30px;
            transform: translateY(-50%);
        }

        .report-content-icon {
            //position: absolute;
            background: #4326CC;
            border-radius: 16px 0px 0px 0px;
            padding: 15px 32px;
            font-size: 24px;
            font-weight: 500;
            color: #FFFFFF;
            display: inline-block;
        }

        .line-box {
            width: 100%;
            height: 0px;
            opacity: 1;
            border: 2px solid #EAEAEA;
        }

        .report-info-box {
            padding: 16px 32px;

            .report-info-item {
                //height: 40px;
                //border: solid black 1px;
                display: flex;
                font-size: 24px;
                font-weight: 400;
                margin-top: 16px;
                color: #333333;

                .report-item-title {
                    width: 120px;
                    line-height: 24px;
                }

                .report-item-content {
                    flex: 1;
                    line-height: 24px;
                }
            }
        }
    }
}
</style>
